module.exports = __webpack_public_path__ + "static/img/10004 (3).c8d834a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10004 (3).webp
// module id = jtmO
// module chunks = 14